import fragments from './fragments';

const displacementLosAsMarkers = {
	key: 'displacementLosAsMarkers',
	data: {
		nameDisplay: 'Displacement',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBase,
						fragments.velAvg,
						fragments.losCohFilter,
					],
				},
			],
		},
	},
};

const displacementLosAsPoints = {
	key: 'displacementLosAsPoints',
	data: {
		nameDisplay: 'Displacement',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPoints,
						fragments.velAvg,
						fragments.losCohFilterAsPoint,
					],
				},
			],
		},
	},
};

const displacementLosAsPointsSmall = {
	key: 'displacementLosAsPointsSmall',
	data: {
		nameDisplay: 'Displacement',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPointsSmall,
						fragments.velAvg,
						fragments.losCohFilterAsPoint,
					],
				},
			],
		},
	},
};

const displacementDtsAsMarkers = {
	key: 'displacementDtsAsMarkers',
	data: {
		nameDisplay: 'Displacement',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBase,
						fragments.velAvg,
						fragments.dtsSensFilter,
					],
				},
			],
		},
	},
};

const displacementDtsAsPoints = {
	key: 'displacementDtsAsPoints',
	data: {
		nameDisplay: 'Displacement',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPoints,
						fragments.velAvg,
						fragments.dtsSensFilterAsPoint,
					],
				},
			],
		},
	},
};

const displacementDtsAsPointsSmall = {
	key: 'displacementDtsAsPointsSmall',
	data: {
		nameDisplay: 'Displacement',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPointsSmall,
						fragments.velAvg,
						fragments.dtsSensFilterAsPoint,
					],
				},
			],
		},
	},
};

const trendDynamicsLosAsMarkers = {
	key: 'trendDynamicsLosAsMarkers',
	data: {
		nameDisplay: 'Trend dynamics',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBase,
						fragments.clDyn,
						fragments.losCohFilter,
					],
				},
			],
		},
	},
};

const trendDynamicsLosAsPoints = {
	key: 'trendDynamicsLosAsPoints',
	data: {
		nameDisplay: 'Trend dynamics',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPoints,
						fragments.clDyn,
						fragments.losCohFilterAsPoint,
					],
				},
			],
		},
	},
};

const trendDynamicsLosAsPointsSmall = {
	key: 'trendDynamicsLosAsPointsSmall',
	data: {
		nameDisplay: 'Trend dynamics',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPointsSmall,
						fragments.clDyn,
						fragments.losCohFilterAsPoint,
					],
				},
			],
		},
	},
};

const trendDynamicsDtsAsMarkers = {
	key: 'trendDynamicsDtsAsMarkers',
	data: {
		nameDisplay: 'Trend dynamics',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBase,
						fragments.clDyn,
						fragments.dtsSensFilter,
					],
				},
			],
		},
	},
};

const trendDynamicsDtsAsPoints = {
	key: 'trendDynamicsDtsAsPoints',
	data: {
		nameDisplay: 'Trend dynamics',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPoints,
						fragments.clDyn,
						fragments.dtsSensFilterAsPoint,
					],
				},
			],
		},
	},
};

const trendDynamicsDtsAsPointsSmall = {
	key: 'trendDynamicsDtsAsPointsSmall',
	data: {
		nameDisplay: 'Trend dynamics',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPointsSmall,
						fragments.clDyn,
						fragments.dtsSensFilterAsPoint,
					],
				},
			],
		},
	},
};

const trendClusterVertggpsAsMarkers = {
	key: 'trendClusterVertggpsAsMarkers',
	data: {
		nameDisplay: 'Trend cluster',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBase,
						fragments.clClstr,
						fragments.vertggpsClusterCohFilter,
					],
				},
			],
		},
	},
};

const trendClusterVertggpsAsPoints = {
	key: 'trendClusterVertggpsAsPoints',
	data: {
		nameDisplay: 'Trend cluster',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPoints,
						fragments.clClstr,
						fragments.vertggpsClusterCohFilterAsPoint,
					],
				},
			],
		},
	},
};

const trendClusterVertggpsAsPointsSmall = {
	key: 'trendClusterVertggpsAsPointsSmall',
	data: {
		nameDisplay: 'Trend cluster',
		description: '',
		definition: {
			rules: [
				{
					styles: [
						fragments.interferometryBaseAsPointsSmall,
						fragments.clClstr,
						fragments.vertggpsClusterCohFilterAsPoint,
					],
				},
			],
		},
	},
};

const zonesTypology = {
	key: 'zonesTypology',
	data: {
		nameDisplay: 'Typology',
		nameInternal: 'Land use classes',
		description: '',
		definition: {
			rules: [
				{
					styles: [fragments.zoneBase, fragments.landUseClassification],
				},
			],
		},
	},
};

const zonesTypologySmall = {
	key: 'zonesTypologySmall',
	data: {
		nameDisplay: 'Typology',
		nameInternal: 'Land use classes',
		description: '',
		definition: {
			rules: [
				{
					styles: [fragments.zoneBaseSmall, fragments.landUseClassification],
				},
			],
		},
	},
};

const zonesExposure = {
	key: 'zonesExposure',
	data: {
		nameDisplay: 'Exposure',
		nameInternal: 'Annual displacement rate [mm/year]',
		description: 'From zonal 75-percentile',
		definition: {
			rules: [
				{
					styles: [
						fragments.zoneBase,
						fragments.exposure,
						fragments.filterNonUrban,
					],
				},
			],
		},
	},
};

const zonesCoastal = {
	key: 'zonesCoastal',
	data: {
		nameDisplay: 'Coastal sectors',
		nameInternal: 'Annual displacement rate [mm/year]',
		description: 'From zonal 75-percentile',
		definition: {
			rules: [
				{
					styles: [fragments.zoneBase, fragments.exposure],
				},
			],
		},
	},
};

const zonesRiparian = {
	key: 'zonesRiparian',
	data: {
		...zonesCoastal.data,
		nameDisplay: 'Stream sectors',
	},
};

const zonesExposureSmall = {
	key: 'zonesExposureSmall',
	data: {
		definition: {
			rules: [
				{
					styles: [
						fragments.zoneBaseSmall,
						fragments.exposure,
						fragments.filterNonUrban,
					],
				},
			],
		},
	},
};

const zonesCoastalSmall = {
	key: 'zonesCoastalSmall',
	data: {
		definition: {
			rules: [
				{
					styles: [fragments.zoneBaseSmall, fragments.exposure],
				},
			],
		},
	},
};

const zonesRiparianSmall = {
	...zonesCoastalSmall,
	key: 'zonesRiparianSmall',
};

const zonesBase = {
	key: 'zonesBase',
	data: {
		nameDisplay: 'Base',
		description: '',
		definition: {
			rules: [
				{
					styles: [fragments.zoneBaseTransparent],
				},
			],
		},
	},
};

const zonesInvisible = {
	key: 'zonesInvisible',
	data: {
		nameDisplay: '-',
		description: '',
		definition: {
			rules: [
				{
					styles: [fragments.zoneBaseInvisible],
				},
			],
		},
	},
};

export default {
	byKey: {
		displacementLosAsMarkers,
		displacementLosAsPoints,
		displacementLosAsPointsSmall,

		displacementDtsAsMarkers,
		displacementDtsAsPoints,
		displacementDtsAsPointsSmall,

		trendDynamicsLosAsMarkers,
		trendDynamicsLosAsPoints,
		trendDynamicsLosAsPointsSmall,

		trendDynamicsDtsAsMarkers,
		trendDynamicsDtsAsPoints,
		trendDynamicsDtsAsPointsSmall,

		trendClusterVertggpsAsMarkers,
		trendClusterVertggpsAsPoints,
		trendClusterVertggpsAsPointsSmall,

		zonesExposure,
		zonesExposureSmall,
		zonesTypology,
		zonesTypologySmall,
		zonesBase,
		zonesInvisible,

		zonesCoastal,
		zonesCoastalSmall,
		zonesRiparian,
		zonesRiparianSmall,
	},
};
